import React from "react";

import clsx from "clsx";

import { Label, Text } from "@busbud/horizon";

import { Rating } from "@app/components/rating/rating";
import { useAppContext } from "@app/helpers/hooks";
import type { NapiTravelReview } from "@app/types/napi-types";

interface Props {
  review: NapiTravelReview;
  className?: string;
}

export const ReviewItem: React.FC<Props> = ({ review, className }) => {
  const { intlProvider } = useAppContext();

  return (
    <div
      key={review.id}
      className={clsx(
        "flex flex-1 flex-col gap-200 border-b-width-sm border-b-color-primary pb-300 last:border-none",
        className
      )}
    >
      <Text
        as="p"
        size="md"
        className="line-clamp-[13] flex-1 overflow-ellipsis"
      >
        {review.content}
      </Text>
      <div className="flex flex-col gap-050">
        <Rating size="sm" rating={review.global_rating} />
        <div className="flex flex-col">
          <Label as="p" fontWeight="bold">
            {review.traveller_name}
          </Label>
          {!!review.review_date && (
            // TODO: Add `datetime` attribute
            <Label as="time" size="sm">
              {intlProvider.formatDate(review.review_date, {
                year: "numeric",
                month: "long",
                day: "numeric"
              })}
            </Label>
          )}
        </div>
      </div>
    </div>
  );
};
